import { FC, useState, useEffect } from 'react'

import { useDataContext } from '../contexts'
import { getGroupedModules, getSimulationsView, TroubleshootingSimsViews, isSim } from '../Reporting'

import { TSModuleProfile } from '../interfaces/ModuleTypes'

import { LoadingIndicator } from '.'
import { TileView } from './dataview'
import { PrimaryHeader } from '../styles/Styles'

const TroubleshootingSimulations: FC = () => {
    const { allProfiles } = useDataContext()
    const [dataViews, setDataViews] = useState<TroubleshootingSimsViews>()

    const simProfiles: TSModuleProfile[] = allProfiles.filter(isSim)

    useEffect(() => {
        if (!simProfiles.length || dataViews) return

        const groupedModules = getGroupedModules(simProfiles)
        const overall = getSimulationsView(simProfiles)

        setDataViews({ overall, groupedModules, })

    }, [dataViews, simProfiles])

    if (!dataViews) return <LoadingIndicator loading={true} timeout={250} />
    return (
        <>
            <PrimaryHeader variant={'h4'}>
                {`Troubleshooting Simulations Data`}
            </PrimaryHeader>
            <TileView dataTiles={dataViews.overall} />
            {
                dataViews.groupedModules.map((sim, key) => <TileView key={'tstv' + key} title={sim.moduleName} dataTiles={getSimulationsView(sim.profiles as TSModuleProfile[])} />)
            }
        </>
    )
}

export default TroubleshootingSimulations
